// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasStatus_CarregaStatusResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/despesas_status/carrega_status
 *
 * Returns the full list of expense statuses, ordered by titulo ASC,
 * with translated titles applied.
 */
import type { DespesasStatus_StatusRow } from './DespesasStatus_StatusRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type DespesasStatus_CarregaStatusResponseDados = DespesasStatus_StatusRow[];

export type DespesasStatus_CarregaStatusResponse = ApiResponse<DespesasStatus_CarregaStatusResponseDados>;

registerResponseContract('DespesasStatus_CarregaStatusResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      despesa_status_id:     { type: 'number',  required: true },
      despesa_status_titulo: { type: 'string',  required: true },
    },
  },
})
